/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdDocuments202,
  PutApiV1PersonIdDocuments400,
  PutApiV1PersonIdDocuments401,
  PutApiV1PersonIdDocuments404,
  PutApiV1PersonIdDocuments409,
  PutApiV1PersonIdDocuments500,
  PutApiV1PersonIdDocumentsMutationRequest,
  PutApiV1PersonIdDocumentsMutationResponse,
  PutApiV1PersonIdDocumentsPathParams,
} from "../../types/personRegisterController/PutApiV1PersonIdDocuments.ts";
import { personDocumentDataViewModelSchema } from "../personDocumentDataViewModelSchema.ts";
import { updateDocumentDataRequestSchema } from "../updateDocumentDataRequestSchema.ts";

export const putApiV1PersonIdDocumentsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdDocumentsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1PersonIdDocuments202Schema = z.lazy(
  () => personDocumentDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdDocuments202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdDocuments400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdDocuments400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdDocuments401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdDocuments401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdDocuments404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdDocuments404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1PersonIdDocuments409Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdDocuments409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdDocuments500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdDocuments500>;

export const putApiV1PersonIdDocumentsMutationRequestSchema = z.lazy(
  () => updateDocumentDataRequestSchema,
) as unknown as ToZod<PutApiV1PersonIdDocumentsMutationRequest>;

export const putApiV1PersonIdDocumentsMutationResponseSchema = z.lazy(
  () => putApiV1PersonIdDocuments202Schema,
) as unknown as ToZod<PutApiV1PersonIdDocumentsMutationResponse>;
